import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Organizations = lazy(() => import('../../../container/organizations'));
const View = lazy(() => import('../../../container/organizations/View'));
const Add = lazy(() => import('../../../container/organizations/Add'));
const Edit = lazy(() => import('../../../container/organizations/Edit'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/organizations`} component={Organizations} />
      <Route exact path={`${path}/organizations/add`} component={Add} />
      <Route exact path={`${path}/organizations/view/:slug`} component={View} />
      <Route exact path={`${path}/organizations/edit/:slug`} component={Edit} />
    </Switch>
  );
}

export default PagesRoute;
